import { html as e, when as a, slotted as n } from "@microsoft/fast-element";
import { SubNavItem as l } from "../sub-nav-item/index.js";
import { toRem as v } from "../../common/css-utils.js";
const d = (i) => {
  const s = e.partial(i.prefix);
  return e`
    <div class="control" part="control">
      <div class="content-wrapper" @click="${(t) => t.navItemClicked()}">
        <slot name="icon"></slot>
        <span class="content">
        <slot name="title"></slot>
      </span>
        <${s}-icon
          class="${(t) => t.subNavItems && t.subNavItems.length > 0 ? "" : "hidden"}"
          name="${(t) => t.active ? "chevron-down" : "chevron-right"}"
          size="${v(1)}"
        ></${s}-icon>
      </div>

      ${a(
    (t) => t.active && t.subNavItems && t.subNavItems.length > 0,
    e` <div class="divider"></div>`
  )}

      <div
        class="items ${(t) => t.active && t.subNavItems && t.subNavItems.length > 0 ? "" : "hidden"}"
        @toggle-sub-nav-item="${(t, o) => t.toggleSubNavItems(o)}"
      >
        <slot
          ${n({
    property: "subNavItems",
    filter: (t) => t instanceof l
  })}
        ></slot>
      </div>
    </div>
  `;
};
export {
  d as navItemTemplate
};
